import {useEffect, useRef, useState} from "react";
import {garrisonTimelineViewLayoutSize as layout} from "../../../utils/garrison-timeline-utils.js";
import GarrisonTimelineIcon from "./garrison-timeline-icon.jsx";
import Button from "../../../../../../components/button/button.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import {buildGarrisonRouteUrl} from "../../../utils/garrison-timeline-utils.js";
import SRoute from "../../../../../../components/icons/route.jsx";
import GarrisonTimelinePagination from "./garrison-timeline-pagination.jsx";

const GarrisonTimelineList = ({data, filter, isMap, hasNextPage, isFetchingNextPage, onLoadMore, showHeader = true}) => {
  const garrisons = data?.garrisons ?? [];
  const navigate = navigateHook();
  const listRef = useRef(null);
  const [truncatedGarrisonIds, setTruncatedGarrisonIds] = useState(new Set());
  const listBorderClass = showHeader ? "border" : isMap ? "border-x border-b" : "border-x";
  const itemBorderClass = isMap ? "border-b last:border-b-0" : "border-b";

  useEffect(() => {
    const updateTruncatedGarrisons = () => {
      const nextTruncatedGarrisonIds = new Set(
        Array.from(listRef.current?.querySelectorAll("[data-garrison-id]") || [])
          .filter(element => element.scrollWidth > element.clientWidth)
          .map(element => element.dataset.garrisonId)
      );

      setTruncatedGarrisonIds(currentIds => {
        const hasChanged = currentIds.size !== nextTruncatedGarrisonIds.size
          || Array.from(currentIds).some(id => !nextTruncatedGarrisonIds.has(id));

        return hasChanged ? nextTruncatedGarrisonIds : currentIds;
      });
    };

    updateTruncatedGarrisons();

    const resizeObserver = new ResizeObserver(updateTruncatedGarrisons);
    if (listRef.current) resizeObserver.observe(listRef.current);

    return () => resizeObserver.disconnect();
  }, [garrisons]);

  return (
    <div className={`flex w-full flex-col ${isMap ? "h-full min-h-0" : "min-h-full self-start"}`}>
      {showHeader && (
        <div className="flex h-[2.1rem] items-center px-2">
          <span className="text-[1.0625rem]">Guarnições</span>
        </div>
      )}
      { (!data?.garrisons || data.garrisons.length === 0) ?
        <div className={`flex min-h-0 flex-1 items-center ${showHeader ? "border" : "border border-t-0"} border-[#E2E8F0] bg-[#f8fafc] p-6 text-center text-gray-500`}>
        <span className="text-[13px] font-medium">
          Nenhuma guarnição com sinal de GPS neste momento.
        </span>
        </div>
        : <ul ref={listRef} className={[isMap ? "min-h-0 flex-1 overflow-y-auto" : "flex-none", listBorderClass, "border-[#E2E8F0]"].join(" ")}>
      {
        garrisons.map(garrison =>
          <li key={garrison.id}
              className={[itemBorderClass, "border-[#E2E8F0] flex items-center px-4 gap-2"].join(" ")}
              style={{height: layout.h + 0.1}}>
            <GarrisonTimelineIcon i={garrison.originalIndex + 1}/>
            <span
              data-garrison-id={garrison.id}
              title={truncatedGarrisonIds.has(String(garrison.id)) ? garrison.name : undefined}
              className="truncate flex-1"
            >
              {garrison.name}
            </span>
            <Button
              title="Visualizar rota completa"
              className="justify-self-end mr-1"
              onClick={() => {
                const routeUrl = buildGarrisonRouteUrl(garrison.id, filter, garrison.originalIndex + 1);

                if (routeUrl) navigate(routeUrl, true);
              }}
            >
              <SRoute/>
            </Button>
          </li>
        )
      }
    </ul>
      }
      <GarrisonTimelinePagination
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onLoadMore={onLoadMore}
      />
    </div>
  )
}

export default GarrisonTimelineList;
